export default {"src":"/_next/static/media/prag-logo.9e7c0f43.svg","height":75,"width":121,"blurWidth":0,"blurHeight":0};